import { render, staticRenderFns } from "./certificationUpgrade.vue?vue&type=template&id=047e9d55&scoped=true&"
import script from "./certificationUpgrade.vue?vue&type=script&lang=js&"
export * from "./certificationUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./certificationUpgrade.vue?vue&type=style&index=0&id=047e9d55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e9d55",
  null
  
)

export default component.exports